import React from 'react';
import { useContext } from 'react';
import Context from '../context/Context';
import { handleInteractionBeacon } from '../helpers/handleInteractionBeacon';

const Pagination = (props) => {
    const { classNames, currentIndexGroup, firstIndex, lastIndex, currentIndex, setCurrentIndex } = props;
    const { criteria, setCriteria } = useContext(Context);

    const handlePaginate = (newCriteria, newIndex) => {
        setCriteria((prevCriteria) => ({
            ...prevCriteria,
            start: newCriteria
        }));

        setCurrentIndex(newIndex);

        const main = document.querySelector('#main');

        main.focus();
    };

    return (
        <>
            <ul className={`pagination flex items-center ${classNames ? classNames : ''}`}>
                {/* Sets up 'First' and 'Prev' paginate buttons */}
                {currentIndex > firstIndex && (
                    <>
                        <li className="pagination-item">
                            <button
                                className={`hover:underline border border-r-0 rounded-tl rounded-bl px-2 py-1`}
                                title="First page"
                                onClick={(event) => {
                                    handlePaginate(criteria.rows * firstIndex, firstIndex);
                                    handleInteractionBeacon( 'cdcarchive-paginatefirst-link', 'o', event.type );
                                }}
                            >First</button>
                        </li>

                        <li className="pagination-item">
                            <button
                                className={`hover:underline border border-r-0 px-2 py-1`}
                                title="Previous page"
                                onClick={(event) => {
                                    handlePaginate(criteria.rows * (currentIndex - 1), currentIndex - 1);
                                    handleInteractionBeacon( 'cdcarchive-paginateprev-link', 'o', event.type );
                                }}
                            >Prev</button>
                        </li>
                    </>
                )}
                
                {/* Sets up 'Current/Active' paginate button */}
                {currentIndexGroup.map((index) => {
                    return (
                        <li
                            className={`pagination-item ${currentIndex === index ? 'active' : ''}`}
                            key={index}
                            aria-label={`page${index+1}`}
                            aria-current={currentIndex === index ? 'page' : false}>
                            <button
                                className={`
                                     hover:underline border border-r-0 px-2 py-1
                                    ${currentIndex === index ? 'bg-blue text-white border-blue pointer-events-none' : ''} 
                                    ${currentIndex === firstIndex && currentIndex === index ? 'rounded-tl rounded-bl' : ''} 
                                    ${currentIndex === lastIndex && currentIndex === index ? 'rounded-tr rounded-br' : ''}
                                `}
                                title={`Page ${index + 1}`}
                                onClick={(event) => {
                                    handlePaginate(criteria.rows * index, index);
                                    handleInteractionBeacon( `cdcarchive-paginate-link`, 'o', event.type );
                                }}
                            >{index + 1}</button>
                        </li>
                    )
                })}

                {/* Sets up 'Next' and 'Last' paginate buttons */}
                {currentIndex < lastIndex && (
                    <>
                        <li className="pagination-item">
                            <button
                                className={`hover:underline border border-r-0 px-2 py-1`}
                                title="Next page"
                                onClick={(event) => {
                                    handlePaginate(criteria.rows * (currentIndex + 1), currentIndex + 1);
                                    handleInteractionBeacon( 'cdcarchive-paginatenext-link', 'o', event.type );
                                }}
                            >Next</button>
                        </li>

                        <li className="pagination-item">
                            <button
                                className={`hover:underline border rounded-tr rounded-br px-2 py-1`}
                                title="Last page"
                                onClick={(event) => {
                                    handlePaginate(criteria.rows * lastIndex, lastIndex);
                                    handleInteractionBeacon( 'cdcarchive-paginatelast-link', 'o', event.type );
                                }}
                            >Last</button>
                        </li>
                    </>
                )}
            </ul>
        </>
    )
}

export default Pagination;
